<template>
  <div>
    <div v-if="!mostrarDetalleFicha" class="card card-custom card-sticky mb-5">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">
            <span class="label label-xl label-dot label-danger mr-2"></span>
            Turno 2 - Mesa
            <small v-if="ui.estaCargandoDatos">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{
              auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="cargar()">
            <i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin' : '']"></i>
          </a>
        </div>
      </div>
    </div>

    <div v-if="mostrarDetalleFicha" class="card card-custom card-sticky mb-5">
    <div class="card-header">
      <div class="card-title">
        <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
          <span class="label label-xl label-dot label-danger mr-2"></span>
          Turno 2 - Mesa
          <small v-if="auth.fechaInicioTurno">{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
        </h3>
      </div>
      <div class="card-toolbar">
        <span class="label label-lg label-inline mr-3" :class="porcentajeAvance >= 100 ? 'label-light-success' : 'label-light-warning'"
              v-b-tooltip.hover.top title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
          {{ Number(porcentajeAvance || 0).toFixed(0) }}% completado
        </span>
        <span v-if="finalizado" class="label label-lg label-inline label-success mr-3">Finalizado</span>
        <button v-if="finalizado && puedeReanudarTurno" type="button" class="btn btn-sm btn-warning font-weight-bold mr-2"
                :disabled="ui.estaGuardando" @click.prevent="reabrir()">Reabrir turno</button>
        <a v-if="!finalizado" href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" :disabled="ui.estaGuardando || soloLectura"
           @click.prevent="guardar(false)">
          <i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i>
          Guardar cambios
        </a>
        <a href="#" class="btn btn-icon btn-sm btn-light-primary"
           @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
          <i :class="expandirContenido ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
        </a>
      </div>
    </div>

    <div class="card-body border-bottom px-3 px-md-9 py-4 py-md-6 bg-white">
      <h5 class="font-weight-bold text-dark mb-4">SECCIÓN 1 - IDENTIFICACIÓN</h5>

      <div class="form-group row">
        <div class="col-12 col-md-4">
          <label class="mb-1">Número de mesa</label>
          <input type="text" class="form-control" v-model="actual.t2NumeroMesaIngresado"
                 placeholder="Número de mesa..." :disabled="soloLectura" />
          <small v-if="actual.t2NumeroMesaIngresado && !numeroMesaConfirmado" class="text-danger">
            El número ingresado no coincide con el de la mesa asignada.
          </small>
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">Nombre y Apellido del Observador/a</label>
          <input type="text" class="form-control" v-model="actual.t2ObservadorNombre" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">DNI</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="actual.t2ObservadorDni"
                   placeholder="DNI o documento..." :disabled="soloLectura" />
            <consulta-voluntario v-if="puedeConsultarVoluntario"
                                 :documento="actual.t2ObservadorDni"
                                 :mesa-votacion-id="mesaVotacionId"
                                 :proceso-electoral-id="procesoElectoralId"
                                 :turno="2" />
          </div>
        </div>
      </div>

      <h6 class="font-weight-bold text-dark mb-3 mt-2">REGISTRO DE ASISTENCIA</h6>

      <div class="form-group row mb-0">
        <div class="col-12 col-md-4">
          <label class="mb-1">Hora de ingreso <span class="text-muted">(1 pm)</span></label>
          <input type="time" class="form-control" v-model="actual.t2HoraIngreso" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4">
          <label class="mb-1">Hora de salida <span class="text-muted">(8pm)</span></label>
          <input type="time" class="form-control" v-model="actual.t2HoraSalida" :disabled="soloLectura" />
        </div>
        <div class="col-12 col-md-4 d-flex align-items-end">
          <button type="button" class="btn btn-block font-weight-bold"
                  :class="[actual.t2HoraIngreso ? 'btn-success' : 'btn-primary']"
                  :disabled="soloLectura" @click.prevent="registrarAsistencia()">
            <i v-if="actual.t2HoraIngreso" class="fa fa-check mr-1"></i>
            REGISTRA TU ASISTENCIA
          </button>
        </div>
      </div>

      <div v-if="!cuestionarioHabilitado" class="alert alert-custom alert-light-info mt-4 mb-0">
        <div class="alert-text">
          Completa el nombre del observador, el DNI y el número de mesa, y registra tu hora de ingreso,
          para habilitar el cuestionario.
        </div>
      </div>

      <div v-else-if="!expandirContenido" class="text-center mt-4 pt-3 border-top">
        <a href="#" class="font-weight-bold btn btn-light-primary" @click.prevent="$emit('update:expandirContenido', true)">Ver ficha <i class="fa fa-chevron-down ml-1"></i></a>
      </div>
    </div>

    <div v-show="expandirContenido && mostrarDetalleFicha" class="card-body px-3 px-md-9 py-4 py-md-8">
        <form v-if="cuestionarioHabilitado" class="form" id="frm-mesa-erm-prov-2026-turno-2">
          <q-seccion titulo="SECCIÓN 2 - INICIO DE LA OBSERVACIÓN ELECTORAL">
            <q-si-no v-model="actual.t2PermitioIngresoLocal"
                     label="2.1 ¿Se te permitió el ingreso al local de votación?"
                     :solo-lectura="soloLectura" @cambio="cambiarPermisoIngreso" />

            <q-multiple :valores="actual" label="2.2 ¿Qué actores se encuentran en el local de votación?"
                        :opciones="opcionesActores" :aplica="fichaActiva" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-si-no v-model="actual.t2SenializacionAdecuada"
                     label="2.3 ¿La señalización y acondicionamiento del local de votación fue adecuada? (señalización de entrada, salida, croquis de ubicación de mesas)"
                     :aplica="fichaActiva" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PersonalOrientadorOnpe"
                     label="2.4 ¿Hubo personal orientador de la ONPE para los electores ?"
                     :aplica="fichaActiva" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2TodasMesasInstaladas"
                     label="2.5 ¿Se instalaron todas las mesas del local de votación?"
                     :aplica="fichaActiva" :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t2TodasMesasInstaladas')" />

            <q-numero v-model="actual.t2CantidadMesasNoInstaladas"
                      label="Si la respuesta fue NO, indique cuántas mesas no se instalaron:"
                      :aplica="actual.t2TodasMesasInstaladas === false" :solo-lectura="soloLectura" />
          </q-seccion>

          <div v-if="!fichaActiva" class="alert alert-custom alert-light-danger">
            <div class="alert-text">
              Registraste que no se te permitió el ingreso al local de votación. No corresponde completar el resto
              de la ficha; comunícate con tu coordinador.
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 3 - ACCESIBILIDAD" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2LocalRampas" label="3.1 ¿El local cuenta con rampas de accesibilidad?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t2LocalBanosAguaPotable"
                     label="3.2 ¿El local cuenta con baños habilitados con agua potable para su uso?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t2LocalMtv" label="3.3 ¿El local cuenta con el Módulo Temporal de Votación (MTV)?" :solo-lectura="soloLectura" />
            <q-si-no v-model="actual.t2LocalZonaSegura"
                     label="3.4 ¿El local cuenta con señalización de zona segura en caso de sismos?" :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 4 - VOTACIÓN EN LA MESA DE SUFRAGIO" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2InterrupcionSufragio"
                     label="4.1 ¿Hubo alguna interrupción durante el proceso de sufragio?"
                     incidencia :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2InterrupcionSufragio')" />

            <q-multiple :valores="actual" label="Si la respuesta es Si, indique el motivo:"
                        :opciones="opcionesMotivoInterrupcion" :aplica="actual.t2InterrupcionSufragio === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2InterrupOtroDetalle" label="Otro:" placeholder="Indique el motivo..."
                     :aplica="actual.t2InterrupOtro === true" :solo-lectura="soloLectura" />

            <q-si-no-no-aplica v-model="actual.t2AtencionPrioritaria"
                               label="4.2 ¿Se observó atención prioritaria en la mesa de sufragio? (a personas con discapacidad, madres gestantes, adultos mayores)"
                               :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2ActoIntimidacion"
                     label="4.3 ¿Se ha detectado algun acto de intimidación, coacción, agresión o violencia que impida el ejercicio del voto ciudadano en la mesa de votación?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2ActoIntimidacion')" />

            <q-texto v-model="actual.t2ActoIntimidacionDetalle" label="Si la respuesta fue Si, indique el motivo"
                     placeholder="Describa el hecho observado..." :aplica="actual.t2ActoIntimidacion === true"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2HechoImpideLaborSufragio"
                     label="4.4 ¿Se presentó/produjo algún hecho que interrumpa o impida el ejercicio de tus funciones como observador/a electoral?"
                     incidencia :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2HechoImpideLaborSufragio')" />

            <q-multiple :valores="actual"
                        label="Si la respuesta fue SI, indique el motivo y comunícate con tu coordinador:"
                        :opciones="opcionesMotivoLaborSufragio" :aplica="actual.t2HechoImpideLaborSufragio === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-multiple :valores="actual" label="Desconocimiento de la labor del observador, ¿por parte de quién?"
                        :opciones="opcionesActorLaborSufragio"
                        :aplica="actual.t2LaborSufragioDesconocimientoLabor === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2LaborSufragioOtroDetalle" label="Otro:" placeholder="Indique el motivo..."
                     :aplica="actual.t2LaborSufragioOtro === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PresenciaPersonerosVotacion"
                     label="4.5 ¿Hay presencia de personeros durante la votación?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2PresenciaPersonerosVotacion')" />

            <q-texto v-model="actual.t2PresenciaPersonerosVotacionOrganizacionesTexto"
                     label="Si la respuesta fue SI, indique de qué organizaciones políticas son los personeros presentes:"
                     placeholder="Indique las organizaciones..."
                     :aplica="actual.t2PresenciaPersonerosVotacion === true"
                     :solo-lectura="soloLectura" />
          </q-seccion>

          <div v-if="fichaActiva" class="alert alert-custom alert-light-info">
            <div class="alert-text">
              <span class="font-weight-bold">PRIMER CORTE DE INFORMACIÓN - 3:30 PM.</span>
              Toda la información recogida en la ficha hasta las 3:30 pm deberás subirla a la plataforma
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 5 - CIERRE DEL SUFRAGIO E INICIO DEL ESCRUTINIO" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2QuedabanElectores1700"
                     label="5.1 A las 17:00 hrs ¿Quedaban electores dentro del local de votación?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2QuedabanElectores1700')" />

            <q-si-no v-model="actual.t2QuedabanElectoresPermitioVotar"
                     label="Si la respuesta fue SI, ¿se les permitió votar?"
                     :aplica="actual.t2QuedabanElectores1700 === true" :solo-lectura="soloLectura" />

            <q-hora v-model="actual.t2HoraInicioEscrutinio"
                    label="5.2 Hora de inicio del escrutinio de la mesa seleccionada."
                    :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PermitioObservadoresEscrutinio"
                     label="5.3 ¿Se permitió la presencia de observadores durante el escrutinio de la mesa selecionada?"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PermitioPersonerosEscrutinio"
                     label="5.4 ¿Se permitió la presencia de personeros acreditados durante el escrutinio de la mesa seleccionada?"
                     :solo-lectura="soloLectura" />

            <q-multiple :valores="actual"
                        label="5.5 ¿Hubo otros actores presentes durante el escrutinio de la mesa selecionada?"
                        ayuda="Marque 1 o más actores electorales"
                        :opciones="opcionesActoresEscrutinio" :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2EscrutinioActorOtrosDetalle" label="Otros:" placeholder="Indique el actor..."
                     :aplica="actual.t2EscrutinioActorOtros === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2ConteoCedulasAnteAsistentes"
                     label="5.6 ¿Los miembros de mesa sacaron las cédulas del ánfora y las contaron en presencia de los asistentes de la mesa selecionada?"
                     :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 6 - ESCRUTINIO Y TRANSPARENCIA EN LOS PROCEDIMIENTOS" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2CedulasCoincidenVotantes"
                     label="6.1 ¿El número total de cédulas del ánfora coincidió con el número de ciudadanos que votaron?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2CedulasCoincidenVotantes')" />

            <q-multiple :valores="actual" label="Si la respuesta fue NO, indique qué hicieron los miembros de mesa:"
                        :opciones="opcionesCedulasNoCoinciden" :aplica="actual.t2CedulasCoincidenVotantes === false"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2CedulasNoCoincidenOtroAccionDetalle" label="Otro acción"
                     placeholder="Indique la acción..." :aplica="actual.t2CedulasNoCoincidenOtroAccion === true"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2MostraronCedulasPublicamente"
                     label="6.2 ¿Los miembros de mesa mostraron públicamente cada cédula al momento de leer y registrar el voto?"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PersonerosAcuerdoActas"
                     label="6.3 ¿Los personeros estuvieron de acuerdo con la información registrada en las actas?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2PersonerosAcuerdoActas')" />

            <q-texto v-model="actual.t2PersonerosAcuerdoActasNoDetalle" label="Si la respuesta fue No, detalla"
                     placeholder="Detalle..." :aplica="actual.t2PersonerosAcuerdoActas === false"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2HuboImpugnacionVoto"
                     label="6.4 ¿Hubo impugnación de voto en la mesa?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2HuboImpugnacionVoto')" />

            <q-texto v-model="actual.t2ImpugnacionVotoNoDetalle" label="Si la respuesta fue Sí, detalla"
                     placeholder="Detalle..." :aplica="actual.t2HuboImpugnacionVoto === true"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PedidoNulidadMesa"
                     label="6.5 ¿Hubo algún pedido de nulidad de la mesa por parte de los personeros?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2PedidoNulidadMesa')" />

            <q-texto v-model="actual.t2PedidoNulidadMesaNoDetalle" label="Si la respuesta fue Sí, detalla"
                     placeholder="Detalle..." :aplica="actual.t2PedidoNulidadMesa === true"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2IncidenteAltercadoEscrutinio"
                     label="6.6 ¿Se registró algún incidente o altercado entre los presentes durante el escrutinio?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2IncidenteAltercadoEscrutinio')" />

            <q-multiple :valores="actual" label="Si la respuesta fue Sí, indique qué tipo de incidente hubo:"
                        :opciones="opcionesIncidenteEscrutinio" :aplica="actual.t2IncidenteAltercadoEscrutinio === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2IncidenteEscrutinioOtroDetalle" label="Otro"
                     placeholder="Indique el tipo..." :aplica="actual.t2IncidenteEscrutinioOtro === true"
                     :solo-lectura="soloLectura" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 7 - LLENADO DE ACTAS ELECTORALES" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2MiembrosAcuerdoActas"
                     label="7.1 ¿Estuvieron de acuerdo todos los miembros de mesa con la información registrada en las actas?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2MiembrosAcuerdoActas')" />

            <q-texto v-model="actual.t2MiembrosAcuerdoActasNoDetalle" label="Si la respuesta fue No, detalla"
                     placeholder="Detalle..." :aplica="actual.t2MiembrosAcuerdoActas === false"
                     :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2DificultadesLlenadoActas"
                     label="7.2 ¿Los miembros de mesa tuvieron dificultades para el llenados de las actas de escrutinio?"
                     :solo-lectura="soloLectura" @cambio="limpiarDependientes('t2DificultadesLlenadoActas')" />

            <q-si-no v-model="actual.t2DificultadesLlenadoRecibioAsistenciaOnpe"
                     label="Si la respuesta fue SI, ¿recibieron asistencia del personal de la ONPE?"
                     :aplica="actual.t2DificultadesLlenadoActas === true" :solo-lectura="soloLectura" />

            <div class="alert alert-custom alert-light-info">
              <div class="alert-text">
                No olvides tomar foto al acta del escrutinio y subirla en la plataforma
              </div>
            </div>

            <ficha-acta-escrutinio v-model="actual.rutaActaEscrutinio"
                                   controlador="Ficha2026ErmProvincia"
                                   :local-votacion-mesa-proceso-electoral-id="asignacionId || localVotacionMesaProcesoElectoralId"
                                   :mesa-votacion-id="mesaVotacionId"
                                   :proceso-electoral-id="procesoElectoralId"
                                   :solo-lectura="soloLectura"
                                   @guardado="onActaGuardada" />
          </q-seccion>

          <q-seccion titulo="SECCIÓN 8 - ENTORNO DEL LOCAL DE VOTACIÓN" :aplica="fichaActiva">
            <q-si-no v-model="actual.t2PropagandaDentroLocal"
                     label="8.1 ¿Existe propaganda política dentro del local de votación?"
                     :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t2PropagandaDentroLocal')" />

            <q-multiple :valores="actual" label="Si la respuesta fue SI, indique el tipo:"
                        :opciones="opcionesPropDentroLocal" :aplica="actual.t2PropagandaDentroLocal === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2PropDentroOtraDetalle" label="Otra:" placeholder="Indique el tipo..."
                     :aplica="actual.t2PropDentroOtra === true" :solo-lectura="soloLectura" />

            <q-si-no v-model="actual.t2PropagandaFueraLocal"
                     label="8.2 ¿Existe propaganda política fuera del local de votación?"
                     :solo-lectura="soloLectura"
                     @cambio="limpiarDependientes('t2PropagandaFueraLocal')" />

            <q-multiple :valores="actual" label="Si la respuesta fue SI, indique el tipo:"
                        :opciones="opcionesPropFueraLocal" :aplica="actual.t2PropagandaFueraLocal === true"
                        :solo-lectura="soloLectura" @cambio="asignar" />

            <q-texto v-model="actual.t2PropFueraOtraDetalle" label="Otra:" placeholder="Indique el tipo..."
                     :aplica="actual.t2PropFueraOtra === true" :solo-lectura="soloLectura" />
          </q-seccion>

          <div v-if="fichaActiva" class="alert alert-custom alert-light-info">
            <div class="alert-text">
              <span class="font-weight-bold">SEGUNDO CORTE DE INFORMACIÓN 6:00 PM</span>
              Toda la información recogida en la ficha hasta las 6:00 pm deberás subirla a la plataforma
            </div>
          </div>

          <q-seccion titulo="SECCIÓN 9 - REGISTRO DE INCIDENCIAS" :aplica="fichaActiva"
                     descripcion="Revisa la cartilla para identificar el tipo de incidencia y reporta el hechoen la plataforma. Describe los hechos de manera breve, identifica actores involucrados e indica la ubicación (interior del local, exterior, mesa de sufragio, ingreso, etc.). No olvides adjuntar la evidencia y reportar la incidencia a tu coordinador.">
            <ficha-incidencias :local-votacion-mesa-proceso-electoral-id="asignacionId || localVotacionMesaProcesoElectoralId"
                               :mesa-votacion-id="mesaVotacionId" :proceso-electoral-id="procesoElectoralId"
                               :turno="2" :solo-lectura="soloLectura" />
          </q-seccion>

          <div class="separator separator-dashed my-6"></div>

          <div class="d-flex justify-content-between align-items-center flex-wrap">
            <div class="text-muted">
              <span v-if="camposPendientes.length"
                    v-b-tooltip.hover.top
                    title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
                <b>{{ camposPendientes.length }}</b> respuestas pendientes
              </span>
              <span v-else class="text-success font-weight-bold">Todas las respuestas obligatorias están completas.</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <span class="label label-lg label-inline mr-3" :class="porcentajeAvance >= 100 ? 'label-light-success' : 'label-light-warning'"
                    v-b-tooltip.hover.top
                    title="Se consideran respuestas guardadas, para actualizar el número guarde los cambios">
                {{ Number(porcentajeAvance || 0).toFixed(0) }}% completado
              </span>
              <template v-if="!finalizado">
                <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" :disabled="ui.estaGuardando || soloLectura"
                   @click.prevent="guardar(false)">
                  <i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i>
                  Guardar cambios
                </a>
                <button type="button" class="btn btn-sm btn-primary" :disabled="ui.estaGuardando || soloLectura || camposPendientes.length > 0"
                        @click.prevent="finalizar()">Finalizar turno 2</button>
              </template>
              <button v-else-if="puedeReanudarTurno" type="button" class="btn btn-sm btn-warning"
                      :disabled="ui.estaGuardando" @click.prevent="reabrir()">Reabrir turno</button>
            </div>
          </div>
        </form>
    </div>
    </div>
  </div>
</template>

<script>
/**
 * Ficha de observación electoral integral ERM 2026 - Provincias, Turno 2.
 * Literales y numeración del PDF "Ficha PROV Turno 2".
 */
import QSeccion from "../ui/QSeccion";
import QSiNo from "../ui/QSiNo";
import QSiNoNoAplica from "../ui/QSiNoNoAplica";
import QMultiple from "../ui/QMultiple";
import QTexto from "../ui/QTexto";
import QNumero from "../ui/QNumero";
import QHora from "../ui/QHora";
import FichaIncidencias from "../FichaIncidencias";
import FichaActaEscrutinio from "../FichaActaEscrutinio";
import ConsultaVoluntario from "../ui/ConsultaVoluntario";

const DEPENDIENTES = {
  t2TodasMesasInstaladas: ["t2CantidadMesasNoInstaladas"],
  t2InterrupcionSufragio: [
    "t2InterrupAusenciaMiembrosMesa",
    "t2InterrupTrasladoMtv",
    "t2InterrupAltercadoActores",
    "t2InterrupOtro",
  ],
  t2InterrupOtro: ["t2InterrupOtroDetalle"],
  t2ActoIntimidacion: ["t2ActoIntimidacionDetalle"],
  t2HechoImpideLaborSufragio: [
    "t2LaborSufragioDesconocimientoLabor",
    "t2LaborSufragioRestriccionMovilizarse",
    "t2LaborSufragioRestriccionObservarMesa",
    "t2LaborSufragioFaltaRespetoAgresion",
    "t2LaborSufragioSeparacionInconducta",
    "t2LaborSufragioOtro",
  ],
  t2LaborSufragioDesconocimientoLabor: [
    "t2LaborSufragioActorJne",
    "t2LaborSufragioActorOnpe",
    "t2LaborSufragioActorFfaaPnp",
  ],
  t2LaborSufragioOtro: ["t2LaborSufragioOtroDetalle"],
  t2PresenciaPersonerosVotacion: ["t2PresenciaPersonerosVotacionOrganizacionesTexto"],
  t2QuedabanElectores1700: ["t2QuedabanElectoresPermitioVotar"],
  t2EscrutinioActorOtros: ["t2EscrutinioActorOtrosDetalle"],
  t2CedulasCoincidenVotantes: [
    "t2CedulasNoCoincidenMasCedulasDesechoAzar",
    "t2CedulasNoCoincidenMenosCedulasAnotaronActa",
    "t2CedulasNoCoincidenDesconocianProcedimiento",
    "t2CedulasNoCoincidenOtroAccion",
  ],
  t2CedulasNoCoincidenOtroAccion: ["t2CedulasNoCoincidenOtroAccionDetalle"],
  t2PersonerosAcuerdoActas: ["t2PersonerosAcuerdoActasNoDetalle"],
  t2HuboImpugnacionVoto: ["t2ImpugnacionVotoNoDetalle"],
  t2PedidoNulidadMesa: ["t2PedidoNulidadMesaNoDetalle"],
  t2IncidenteAltercadoEscrutinio: [
    "t2IncidenteEscrutinioPersonerosNoFacultados",
    "t2IncidenteEscrutinioAgresionActores",
    "t2IncidenteEscrutinioNoPublico",
    "t2IncidenteEscrutinioOtro",
  ],
  t2IncidenteEscrutinioOtro: ["t2IncidenteEscrutinioOtroDetalle"],
  t2MiembrosAcuerdoActas: ["t2MiembrosAcuerdoActasNoDetalle"],
  t2DificultadesLlenadoActas: ["t2DificultadesLlenadoRecibioAsistenciaOnpe"],
  t2PropagandaDentroLocal: [
    "t2PropDentroBarrasPortatiles",
    "t2PropDentroManifestaciones",
    "t2PropDentroMaterialGrafico",
    "t2PropDentroVestimentaIndumentaria",
    "t2PropDentroOtra",
  ],
  t2PropDentroOtra: ["t2PropDentroOtraDetalle"],
  t2PropagandaFueraLocal: [
    "t2PropFueraBarrasPortatiles",
    "t2PropFueraManifestaciones",
    "t2PropFueraMaterialGrafico",
    "t2PropFueraVestimentaIndumentaria",
    "t2PropFueraVehiculos",
    "t2PropFueraOtra",
  ],
  t2PropFueraOtra: ["t2PropFueraOtraDetalle"],
};

const CAMPOS_POSTERIORES_A_INGRESO = [
  "t2ActorOnpe",
  "t2ActorJne",
  "t2ActorFfaaPnp",
  "t2ActorDefensoriaPueblo",
  "t2ActorMinisterioPublico",
  "t2ActorOtrosObservadoresNacionales",
  "t2ActorObservadoresInternacionales",
  "t2ActorSerenazgo",
  "t2SenializacionAdecuada",
  "t2PersonalOrientadorOnpe",
  "t2TodasMesasInstaladas",
  "t2LocalRampas",
  "t2LocalBanosAguaPotable",
  "t2LocalMtv",
  "t2LocalZonaSegura",
  "t2InterrupcionSufragio",
  "t2AtencionPrioritaria",
  "t2ActoIntimidacion",
  "t2HechoImpideLaborSufragio",
  "t2PresenciaPersonerosVotacion",
  "t2QuedabanElectores1700",
  "t2HoraInicioEscrutinio",
  "t2PermitioObservadoresEscrutinio",
  "t2PermitioPersonerosEscrutinio",
  "t2EscrutinioActorOnpe",
  "t2EscrutinioActorJne",
  "t2EscrutinioActorDefensoriaPueblo",
  "t2EscrutinioActorMinisterioPublico",
  "t2EscrutinioActorOtros",
  "t2ConteoCedulasAnteAsistentes",
  "t2CedulasCoincidenVotantes",
  "t2MostraronCedulasPublicamente",
  "t2PersonerosAcuerdoActas",
  "t2HuboImpugnacionVoto",
  "t2PedidoNulidadMesa",
  "t2IncidenteAltercadoEscrutinio",
  "t2MiembrosAcuerdoActas",
  "t2DificultadesLlenadoActas",
  "t2PropagandaDentroLocal",
  "t2PropagandaFueraLocal",
];

export default {
  name: "Ficha2026ErmProvinciaTurno2",
  components: {
    QSeccion,
    QSiNo,
    QSiNoNoAplica,
    QMultiple,
    QTexto,
    QNumero,
    QHora,
    FichaIncidencias,
    FichaActaEscrutinio,
    ConsultaVoluntario,
  },
  props: {
    localVotacionMesaProcesoElectoralId: { type: [Number, String], default: null },
    mesaVotacionId: { type: [Number, String], required: true },
    procesoElectoralId: { type: [Number, String], required: true },
    cabecera: { type: Object, default: () => ({}) },
    expandirContenido: { type: Boolean, default: true },
    intervaloAutoGuardado: { type: Number, default: 5000 },
  },
  data() {
    return {
      ui: { estaGuardando: false, estaCargandoDatos: false, tieneCargaInicial: false },
      auth: {},
      porcentajeAvance: 0,
      finalizado: false,
      camposPendientes: [],
      numeroMesaEsperado: "",
      asignacionId: null,
      temporizador: null,
      actual: {
        t2ObservadorNombre: null,
        t2ObservadorDni: null,
        t2NumeroMesaIngresado: null,
        t2HoraIngreso: null,
        t2HoraSalida: null,
        t2PermitioIngresoLocal: null,
        t2ActorOnpe: null,
        t2ActorJne: null,
        t2ActorFfaaPnp: null,
        t2ActorDefensoriaPueblo: null,
        t2ActorMinisterioPublico: null,
        t2ActorOtrosObservadoresNacionales: null,
        t2ActorObservadoresInternacionales: null,
        t2ActorSerenazgo: null,
        t2SenializacionAdecuada: null,
        t2PersonalOrientadorOnpe: null,
        t2TodasMesasInstaladas: null,
        t2CantidadMesasNoInstaladas: null,
        t2LocalRampas: null,
        t2LocalBanosAguaPotable: null,
        t2LocalMtv: null,
        t2LocalZonaSegura: null,
        t2InterrupcionSufragio: null,
        t2InterrupAusenciaMiembrosMesa: null,
        t2InterrupTrasladoMtv: null,
        t2InterrupAltercadoActores: null,
        t2InterrupOtro: null,
        t2InterrupOtroDetalle: null,
        t2AtencionPrioritaria: null,
        t2ActoIntimidacion: null,
        t2ActoIntimidacionDetalle: null,
        t2HechoImpideLaborSufragio: null,
        t2LaborSufragioDesconocimientoLabor: null,
        t2LaborSufragioRestriccionMovilizarse: null,
        t2LaborSufragioRestriccionObservarMesa: null,
        t2LaborSufragioFaltaRespetoAgresion: null,
        t2LaborSufragioSeparacionInconducta: null,
        t2LaborSufragioOtro: null,
        t2LaborSufragioOtroDetalle: null,
        t2LaborSufragioActorJne: null,
        t2LaborSufragioActorOnpe: null,
        t2LaborSufragioActorFfaaPnp: null,
        t2PresenciaPersonerosVotacion: null,
        t2PresenciaPersonerosVotacionOrganizacionesTexto: null,
        t2QuedabanElectores1700: null,
        t2QuedabanElectoresPermitioVotar: null,
        t2HoraInicioEscrutinio: null,
        t2PermitioObservadoresEscrutinio: null,
        t2PermitioPersonerosEscrutinio: null,
        t2EscrutinioActorOnpe: null,
        t2EscrutinioActorJne: null,
        t2EscrutinioActorDefensoriaPueblo: null,
        t2EscrutinioActorMinisterioPublico: null,
        t2EscrutinioActorOtros: null,
        t2EscrutinioActorOtrosDetalle: null,
        t2ConteoCedulasAnteAsistentes: null,
        t2CedulasCoincidenVotantes: null,
        t2CedulasNoCoincidenMasCedulasDesechoAzar: null,
        t2CedulasNoCoincidenMenosCedulasAnotaronActa: null,
        t2CedulasNoCoincidenDesconocianProcedimiento: null,
        t2CedulasNoCoincidenOtroAccion: null,
        t2CedulasNoCoincidenOtroAccionDetalle: null,
        t2MostraronCedulasPublicamente: null,
        t2PersonerosAcuerdoActas: null,
        t2PersonerosAcuerdoActasNoDetalle: null,
        t2HuboImpugnacionVoto: null,
        t2ImpugnacionVotoNoDetalle: null,
        t2PedidoNulidadMesa: null,
        t2PedidoNulidadMesaNoDetalle: null,
        t2IncidenteAltercadoEscrutinio: null,
        t2IncidenteEscrutinioPersonerosNoFacultados: null,
        t2IncidenteEscrutinioAgresionActores: null,
        t2IncidenteEscrutinioNoPublico: null,
        t2IncidenteEscrutinioOtro: null,
        t2IncidenteEscrutinioOtroDetalle: null,
        t2MiembrosAcuerdoActas: null,
        t2MiembrosAcuerdoActasNoDetalle: null,
        t2DificultadesLlenadoActas: null,
        t2DificultadesLlenadoRecibioAsistenciaOnpe: null,
        t2PropagandaDentroLocal: null,
        t2PropDentroBarrasPortatiles: null,
        t2PropDentroManifestaciones: null,
        t2PropDentroMaterialGrafico: null,
        t2PropDentroVestimentaIndumentaria: null,
        t2PropDentroOtra: null,
        t2PropDentroOtraDetalle: null,
        t2PropagandaFueraLocal: null,
        t2PropFueraBarrasPortatiles: null,
        t2PropFueraManifestaciones: null,
        t2PropFueraMaterialGrafico: null,
        t2PropFueraVestimentaIndumentaria: null,
        t2PropFueraVehiculos: null,
        t2PropFueraOtra: null,
        t2PropFueraOtraDetalle: null,
        rutaActaEscrutinio: null,
      },
      guardado: {},
    };
  },
  computed: {
    mostrarDetalleFicha() {
      return this.ui.tieneCargaInicial && (this.auth.autorizadoEdicionTurno || this.finalizado);
    },
    soloLectura() {
      return this.finalizado || !this.auth.autorizadoEdicionTurno;
    },
    puedeReanudarTurno() {
      return this.auth.puedeReanudarTurno === true;
    },
    puedeConsultarVoluntario() {
      return this.auth.puedeConsultarVoluntario === true || this.$session.get("CodigoRol") === "ADM";
    },
    mesaEsperada() {
      return String(this.numeroMesaEsperado || (this.cabecera && this.cabecera.numeroMesa) || "").trim();
    },
    numeroMesaConfirmado() {
      const ingresado = String(this.actual.t2NumeroMesaIngresado || "").trim();
      const esperado = this.mesaEsperada;
      if (!ingresado) return false;
      if (!esperado) return true;
      return ingresado === esperado;
    },
    mesaPendienteDeIdentificar() {
      return !this.mesaEsperada && String(this.actual.t2NumeroMesaIngresado || "").trim() !== "";
    },
    cuestionarioHabilitado() {
      return (
        String(this.actual.t2ObservadorNombre || "").trim().length > 0 &&
        String(this.actual.t2ObservadorDni || "").trim().length > 0 &&
        this.numeroMesaConfirmado &&
        String(this.actual.t2HoraIngreso || "").trim().length > 0
      );
    },
    fichaActiva() {
      return this.actual.t2PermitioIngresoLocal !== false;
    },
    opcionesActores() {
      return [
        { campo: "t2ActorOnpe", etiqueta: "Personal de la ONPE" },
        { campo: "t2ActorJne", etiqueta: "Personal del JNE" },
        { campo: "t2ActorFfaaPnp", etiqueta: "FFAA / PNP" },
        { campo: "t2ActorDefensoriaPueblo", etiqueta: "Defensoria del Pueblo" },
        { campo: "t2ActorMinisterioPublico", etiqueta: "Ministerio Público" },
        { campo: "t2ActorOtrosObservadoresNacionales", etiqueta: "Otros observadores nacionales" },
        { campo: "t2ActorObservadoresInternacionales", etiqueta: "Observadores internacionales" },
        { campo: "t2ActorSerenazgo", etiqueta: "Serenazgo" },
      ];
    },
    opcionesMotivoInterrupcion() {
      return [
        { campo: "t2InterrupAusenciaMiembrosMesa", etiqueta: "Ausencia de miembros de mesa" },
        { campo: "t2InterrupTrasladoMtv", etiqueta: "Traslado de los miembros de mesa al Módulo Temporal de Votación" },
        { campo: "t2InterrupAltercadoActores", etiqueta: "Altercado entre actores electorales (personeros, JNE, ONPE, etc)" },
        { campo: "t2InterrupOtro", etiqueta: "Otro:" },
      ];
    },
    opcionesMotivoLaborSufragio() {
      return [
        { campo: "t2LaborSufragioDesconocimientoLabor", etiqueta: "Desconocimiento de la labor del observador" },
        { campo: "t2LaborSufragioRestriccionMovilizarse", etiqueta: "Restricción para movilizarse dentro del local de votación" },
        { campo: "t2LaborSufragioRestriccionObservarMesa", etiqueta: "Restricción para observar la mesa de votación" },
        { campo: "t2LaborSufragioFaltaRespetoAgresion", etiqueta: "Falta de respeto, agresión contra el observador" },
        { campo: "t2LaborSufragioSeparacionInconducta", etiqueta: "Separación del observador por inconducta o faltas a la normativa electoral" },
        { campo: "t2LaborSufragioOtro", etiqueta: "Otro" },
      ];
    },
    opcionesActorLaborSufragio() {
      return [
        { campo: "t2LaborSufragioActorJne", etiqueta: "JNE" },
        { campo: "t2LaborSufragioActorOnpe", etiqueta: "ONPE" },
        { campo: "t2LaborSufragioActorFfaaPnp", etiqueta: "FFAA/PNP" },
      ];
    },
    opcionesActoresEscrutinio() {
      return [
        { campo: "t2EscrutinioActorOnpe", etiqueta: "Personal de la ONPE" },
        { campo: "t2EscrutinioActorJne", etiqueta: "Personal del JNE" },
        { campo: "t2EscrutinioActorDefensoriaPueblo", etiqueta: "Defensoria del Pueblo" },
        { campo: "t2EscrutinioActorMinisterioPublico", etiqueta: "Ministerio Público" },
        { campo: "t2EscrutinioActorOtros", etiqueta: "Otros:" },
      ];
    },
    opcionesCedulasNoCoinciden() {
      return [
        {
          campo: "t2CedulasNoCoincidenMasCedulasDesechoAzar",
          etiqueta: "Si hay más cédulas que votantes, los miembros de mesa eligieron una cédula al azar, la desecharon y se anotó el hecho en la sección de observaciones del acta de escrutinio.",
        },
        {
          campo: "t2CedulasNoCoincidenMenosCedulasAnotaronActa",
          etiqueta: "Si hay menos cédulas que votantes, los miembros de mesa anotan el hecho en la sección de observaciones del acta de sufragio.",
        },
        {
          campo: "t2CedulasNoCoincidenDesconocianProcedimiento",
          etiqueta: "Los miembros de mesa desconocían el procedimiento y solicitaron apoyo del personal de la ONPE/ JNE.",
        },
        { campo: "t2CedulasNoCoincidenOtroAccion", etiqueta: "Otro acción" },
      ];
    },
    opcionesIncidenteEscrutinio() {
      return [
        { campo: "t2IncidenteEscrutinioPersonerosNoFacultados", etiqueta: "Personeros no facultados en la mesa" },
        { campo: "t2IncidenteEscrutinioAgresionActores", etiqueta: "Agresión verbal y/o física entre actores electorales" },
        { campo: "t2IncidenteEscrutinioNoPublico", etiqueta: "Impedimento de que el escrutinio sea público (a puerta cerrada)" },
        { campo: "t2IncidenteEscrutinioOtro", etiqueta: "Otro" },
      ];
    },
    opcionesPropDentroLocal() {
      return [
        { campo: "t2PropDentroBarrasPortatiles", etiqueta: "Barras / Portátiles" },
        { campo: "t2PropDentroManifestaciones", etiqueta: "Manifestaciones" },
        { campo: "t2PropDentroMaterialGrafico", etiqueta: "Material grafico" },
        { campo: "t2PropDentroVestimentaIndumentaria", etiqueta: "Vestimenta o indumentaria" },
        { campo: "t2PropDentroOtra", etiqueta: "Otra:" },
      ];
    },
    opcionesPropFueraLocal() {
      return [
        { campo: "t2PropFueraBarrasPortatiles", etiqueta: "Barras / Portátiles" },
        { campo: "t2PropFueraManifestaciones", etiqueta: "Manifestaciones" },
        { campo: "t2PropFueraMaterialGrafico", etiqueta: "Material grafico" },
        { campo: "t2PropFueraVestimentaIndumentaria", etiqueta: "Vestimenta o indumentaria" },
        { campo: "t2PropFueraVehiculos", etiqueta: "Vehículos" },
        { campo: "t2PropFueraOtra", etiqueta: "Otra:" },
      ];
    },
    isDirty() {
      return JSON.stringify(this.actual) !== JSON.stringify(this.guardado);
    },
  },
  watch: {
    actual: {
      deep: true,
      handler() {
        if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos || this.soloLectura) return;
        this.programarAutoGuardado();
      },
    },
  },
  mounted() {
    this.cargar();
  },
  beforeDestroy() {
    if (this.temporizador) clearTimeout(this.temporizador);
  },
  methods: {
    asignar(evento) {
      this.$set(this.actual, evento.campo, evento.valor);
      if (evento.valor !== true) this.limpiarDependientes(evento.campo);
    },
    limpiarDependientes(campo) {
      const hijos = DEPENDIENTES[campo];
      if (!hijos) return;
      this.limpiarCampos(hijos);
    },
    limpiarCampos(campos) {
      campos.forEach((campo) => {
        if (this.actual[campo] !== null && this.actual[campo] !== undefined) {
          this.$set(this.actual, campo, null);
        }
        this.limpiarDependientes(campo);
      });
    },
    hayDatosEn(campos) {
      return campos.some((campo) => {
        const v = this.actual[campo];
        return v !== null && v !== undefined && v !== "";
      });
    },
    confirmarLimpieza(campos, mensaje, revertir) {
      if (!this.hayDatosEn(campos)) {
        this.limpiarCampos(campos);
        return;
      }
      this.$bvModal
        .msgBoxConfirm(mensaje, {
          title: "Confirmar cambio",
          okTitle: "Sí, borrar y continuar",
          cancelTitle: "Cancelar",
          okVariant: "danger",
          centered: true,
        })
        .then((confirmado) => {
          if (confirmado) this.limpiarCampos(campos);
          else if (typeof revertir === "function") revertir();
        });
    },
    cambiarPermisoIngreso(valor) {
      if (valor !== false) return;
      this.confirmarLimpieza(
        CAMPOS_POSTERIORES_A_INGRESO,
        "Se borrarán las respuestas posteriores a esta pregunta. ¿Deseas continuar?",
        () => this.$set(this.actual, "t2PermitioIngresoLocal", true)
      );
    },
    registrarAsistencia() {
      if (this.soloLectura || this.actual.t2HoraIngreso) return;
      const ahora = new Date();
      const hh = String(ahora.getHours()).padStart(2, "0");
      const mm = String(ahora.getMinutes()).padStart(2, "0");
      this.$set(this.actual, "t2HoraIngreso", hh + ":" + mm);
    },
    programarAutoGuardado() {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (this.temporizador) clearTimeout(this.temporizador);
      this.temporizador = setTimeout(() => this.guardar(true), this.intervaloAutoGuardado);
    },
    identificacion() {
      return {
        localVotacionMesaProcesoElectoralId: this.asignacionId || this.localVotacionMesaProcesoElectoralId,
        mesaVotacionId: this.mesaVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };
    },
    actualizarBaseDiferente(propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      const vActual = JSON.stringify(fichaActual[propiedad]);
      const vGuardado = JSON.stringify(fichaGuardado[propiedad]);
      const vActualizado = JSON.stringify(fichaActualizada[propiedad]);
      return vActual === vGuardado && vGuardado !== vActualizado
        ? fichaActualizada[propiedad]
        : fichaActual[propiedad];
    },
    aHoraCorta(valor) {
      const texto = String(valor || "").trim();
      return texto.length >= 5 ? texto.substring(0, 5) : null;
    },
    normalizarFichaServidor(ficha) {
      const normalizada = this.cloneObject(ficha || {});
      ["t2HoraIngreso", "t2HoraSalida", "t2HoraInicioEscrutinio"].forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(normalizada, campo)) {
          normalizada[campo] = this.aHoraCorta(normalizada[campo]);
        }
      });
      return normalizada;
    },
    aplicarMeta(d) {
      this.auth = d.auth || {};
      this.porcentajeAvance = d.porcentajeAvanceTurnoActual || 0;
      this.finalizado = d.tieneRegistroFinalizadoTurnoActual === true;
      this.camposPendientes = d.camposPendientes || [];
      this.numeroMesaEsperado = d.numeroMesaEsperado || "";
      if (d.localVotacionMesaProcesoElectoralId) {
        this.asignacionId = d.localVotacionMesaProcesoElectoralId;
        this.$emit("guardado", d);
      }
    },
    onActaGuardada(datos) {
      if (datos) this.aplicarMeta(datos);
      this.$set(this.guardado, "rutaActaEscrutinio", this.actual.rutaActaEscrutinio);
    },
    aplicarFicha(fichaServidor) {
      const ficha = this.normalizarFichaServidor(fichaServidor);

      if (!this.ui.tieneCargaInicial) {
        Object.keys(this.actual).forEach((campo) => {
          if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
            this.actual[campo] = ficha[campo];
          }
        });
        this.guardado = this.cloneObject(this.actual);
        return;
      }

      const tempActual = this.cloneObject(this.actual);
      const tempGuardado = this.cloneObject(this.guardado);
      Object.keys(tempActual).forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
          tempActual[campo] = this.actualizarBaseDiferente(campo, tempActual, tempGuardado, ficha);
        }
      });
      this.actual = this.cloneObject(tempActual);

      const nuevoGuardado = this.cloneObject(this.guardado);
      Object.keys(this.actual).forEach((campo) => {
        if (Object.prototype.hasOwnProperty.call(ficha, campo)) {
          nuevoGuardado[campo] = ficha[campo];
        }
      });
      this.guardado = nuevoGuardado;
    },
    async cargar() {
      this.ui.estaCargandoDatos = true;
      await this.$http
        .post(this.apiRoute("Ficha2026ErmProvincia", "GetTurnoDos"), this.identificacion())
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) return;
          const d = response.body.data || {};
          this.aplicarMeta(d);
          this.aplicarFicha(d.ficha);
        }, this.mostrarMensajeExcepcionVueResource);
      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
      if (this.isDirty && !this.soloLectura) this.programarAutoGuardado();
    },
    armarRequest() {
      const modelo = this.cloneObject(this.actual);
      Object.assign(modelo, this.identificacion());
      modelo.t2PresenciaPersonerosVotacionOrganizacionParamIds = null;
      delete modelo.rutaActaEscrutinio;
      return modelo;
    },
    async confirmarIdentificacionMesa(silencioso) {
      if (!this.mesaPendienteDeIdentificar) return true;
      if (silencioso) return false;
      const numero = String(this.actual.t2NumeroMesaIngresado || "").trim();
      const confirmado = await this.$bvModal.msgBoxConfirm(
        "Vas a registrar la mesa N° " + numero + ". Después no podrás cambiar este número. Asegúrate de incluir todos los ceros del inicio.",
        {
          title: "Confirmar número de mesa",
          okTitle: "Registrar mesa " + numero,
          cancelTitle: "Revisar",
        }
      );
      return confirmado === true;
    },
    async guardar(silencioso) {
      if (this.ui.estaGuardando || this.soloLectura || this.ui.estaCargandoDatos) return false;
      if (!this.cuestionarioHabilitado) {
        if (!silencioso) {
          this.$bvToast.toast(
            "Completa el nombre del observador, el DNI, el número de mesa y la hora de ingreso antes de guardar.",
            { title: "Turno 2", autoHideDelay: 5000, variant: "warning", solid: true }
          );
        }
        return false;
      }
      if (!(await this.confirmarIdentificacionMesa(silencioso))) return false;
      if (silencioso && !this.isDirty) return false;

      const actualClone = this.cloneObject(this.actual);
      const modelo = this.armarRequest();

      this.ui.estaGuardando = true;
      let exitoso = false;
      await this.$http
        .post(this.apiRoute("Ficha2026ErmProvincia", "EditTurnoDos"), modelo)
        .then(function (response) {
          if (this.procesarRespuestaErrorDefecto(response)) return;
          this.guardado = actualClone;
          exitoso = true;
          this.$emit("guardado", response.body.data);
          if (!silencioso) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 2",
              autoHideDelay: 5000,
              variant: "success",
              solid: true,
            });
          }
        }, this.mostrarMensajeExcepcionVueResource);
      this.ui.estaGuardando = false;

      if (exitoso) await this.cargar();
      return exitoso;
    },
    finalizar() {
      this.$bvModal
        .msgBoxConfirm("¿Confirma que desea finalizar el Turno 2? Después no podrá editarlo.", {
          title: "Finalizar turno",
          okTitle: "Finalizar",
          cancelTitle: "Cancelar",
        })
        .then(async (confirmado) => {
          if (!confirmado) return;
          if (this.isDirty) {
            const guardado = await this.guardar(!this.mesaPendienteDeIdentificar);
            if (!guardado) return;
          }
          this.$http
            .post(this.apiRoute("Ficha2026ErmProvincia", "FinalizarTurno"),
              Object.assign({ turno: 2 }, this.identificacion()))
            .then(function (response) {
              if (this.procesarRespuestaErrorDefecto(response)) {
                const d = response.body.data || {};
                if (d.camposPendientes) this.camposPendientes = d.camposPendientes;
                return;
              }
              this.finalizado = true;
              this.$emit("finalizado", response.body.data);
              this.$bvToast.toast(response.body.message || "Turno finalizado.", {
                title: "Turno 2",
                autoHideDelay: 5000,
                variant: "success",
                solid: true,
              });
            }, this.mostrarMensajeExcepcionVueResource);
        });
    },

    reabrir() {
      this.$bvModal
        .msgBoxConfirm("¿Confirma que desea reabrir el Turno 2? Volverá a ser editable.", {
          title: "Reabrir turno",
          okTitle: "Reabrir",
          cancelTitle: "Cancelar",
        })
        .then((confirmado) => {
          if (!confirmado) return;
          this.ui.estaGuardando = true;
          this.$http
            .post(this.apiRoute("Ficha2026ErmProvincia", "RevertirTurno"),
              Object.assign({ turno: 2 }, this.identificacion()))
            .then(function (response) {
              this.ui.estaGuardando = false;
              if (this.procesarRespuestaErrorDefecto(response)) return;
              this.aplicarMeta(response.body.data || {});
              this.$emit("finalizado", response.body.data);
              this.$bvToast.toast(response.body.message || "Turno reabierto.", {
                title: "Turno 2",
                autoHideDelay: 5000,
                variant: "success",
                solid: true,
              });
            }, function (error) {
              this.ui.estaGuardando = false;
              this.mostrarMensajeExcepcionVueResource(error);
            });
        });
    },
  },
};
</script>
